module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logoutTitle":"Logging out..."},"fr":{"logoutTitle":"Déconnexion en cours..."}}')
  delete Component.options._Ctor
}
